// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"a9291532","297":"a9291532"}[chunkId] + ".chunk.css";
};